import React from 'react'
import { enums } from '@adc/sdk'
import PropTypes from 'prop-types'
import styles from './styles.scss'
import classnames from 'classnames/bind'
import getDisplayIndicator from '../../../utils/getDisplayIndicator'

const cx = classnames.bind(styles)

const MapPin = ({
  listingId,
  dotAssetType = enums.AssetType.BankOwned,
  customClassName,
  style, // inline styles passthrough
  isHovered,
  label,
  seen,
  lighterShadow,
}) => {
  // Combine default and custom class names using cx
  const dotClasses = cx(
    'dot',
    { active: isHovered },
    { 'lighter-box-shadow': lighterShadow },
    customClassName
  )

  const dotColors = getDisplayIndicator({
    listing_configuration: {
      asset_type: dotAssetType,
      product_type: '',
    },
  })

  return label ? (
    <div className={cx('label-container')}>
      <div
        className={dotClasses}
        style={{
          backgroundColor: seen ? dotColors.colorFaded : dotColors.color,
        }}
      />
      {label}
    </div>
  ) : (
    <div
      className={dotClasses}
      id={listingId}
      style={{
        backgroundColor: seen ? dotColors.colorFaded : dotColors.color,
        ...style,
      }}
    />
  )
}

MapPin.propTypes = {
  listingId: PropTypes.string,
  dotAssetType: PropTypes.oneOf(Object.values(enums.AssetType)),
  customClassName: PropTypes.string,
  style: PropTypes.object,
  isHovered: PropTypes.bool,
  lighterShadow: PropTypes.bool,
  seen: PropTypes.bool,
  label: PropTypes.string,
}

export default MapPin
